import React from "react";
import { RenderWhen } from "../../../components";
import { formatHeaderAlertCount } from "../utils";
import RlNavigationIcon from "../navigation/components/RlNavigationIcon";

const HeaderAlertsIcon = ({ count }: { count: number }) => (
  <div
    className="header-alerts__icon-container"
    data-testid="header_alerts_icon"
  >
    <RenderWhen condition={count > 0}>
      <span
        className="header-alerts__count"
        data-testid="header_alerts_icon-count"
      >
        {formatHeaderAlertCount(count)}
      </span>
    </RenderWhen>
    <RlNavigationIcon name="bell-ringing" />
  </div>
);

export default HeaderAlertsIcon;
